import { FormControl, FormHelperText, Select } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { canChangeDefaultCallVisibility } from "../../../utils/permissions";
import {
  CallVisibility,
  useVisibilityLevelDescriptionsQuery,
} from "../../graphql";
import useCurrentUser from "../../hooks/useCurrentUser";

interface UserDefaultCallVisibilitySelectProps {
  formId: string;
  userId: string;
  defaultValue?: string;
  onChange: (callVisibility: CallVisibility) => void;
  size?: "xs" | "sm" | "md" | "lg";
  showDescription?: boolean;
}
const UserDefaultCallVisibilitySelect: React.FC<
  UserDefaultCallVisibilitySelectProps
> = ({
  formId,
  defaultValue,
  userId,
  onChange,
  size,
  showDescription = false,
}) => {
  const currentUser = useCurrentUser();
  const cannotChange = !canChangeDefaultCallVisibility(currentUser, userId);
  const [description, setDescription] = useState("");

  const { data } = useVisibilityLevelDescriptionsQuery({
    onCompleted: (data) => {
      setDescription(
        data?.visibilityLevelDescriptions.find(
          ({ visibilityLevel }) => visibilityLevel === defaultValue
        )?.description || ""
      );
    },
  });
  const visibilityOptions = data?.visibilityLevelDescriptions || [];

  useEffect(() => {
    const descriptionForVisibility =
      visibilityOptions.find(({ visibilityLevel }) => {
        return visibilityLevel === defaultValue;
      })?.description || "";
    setDescription(descriptionForVisibility);
  }, [defaultValue]);

  const onChangeVisibility = (value: CallVisibility): void => {
    onChange(value);
  };

  return (
    <FormControl id={formId}>
      <Select
        disabled={cannotChange}
        value={defaultValue}
        size={size ?? "md"}
        onChange={(e) => onChangeVisibility(e.target.value as CallVisibility)}
      >
        {visibilityOptions
          // The ORGANIZATION visibility level is not used for calls
          .filter(({ visibilityLevel }) => visibilityLevel !== "ORGANIZATION")
          .map(({ visibilityLevel, label }) => (
            <option
              key={visibilityLevel}
              id={visibilityLevel}
              value={visibilityLevel}
            >
              {label}
            </option>
          ))}
      </Select>
      {showDescription && <FormHelperText>{description}</FormHelperText>}
    </FormControl>
  );
};
export default UserDefaultCallVisibilitySelect;
